import React from "react";

const ManifestIcon = (props: any) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.8"
          d="M14.25 15.75H9.75C9.15326 15.75 8.58097 15.9871 8.15901 16.409C7.73705 16.831 7.5 17.4033 7.5 18V19.5H9V18C9 17.8011 9.07902 17.6103 9.21967 17.4697C9.36032 17.329 9.55109 17.25 9.75 17.25H14.25C14.4489 17.25 14.6397 17.329 14.7803 17.4697C14.921 17.6103 15 17.8011 15 18V19.5H16.5V18C16.5 17.4033 16.2629 16.831 15.841 16.409C15.419 15.9871 14.8467 15.75 14.25 15.75ZM12 15C12.5933 15 13.1734 14.8241 13.6667 14.4944C14.1601 14.1648 14.5446 13.6962 14.7716 13.1481C14.9987 12.5999 15.0581 11.9967 14.9424 11.4147C14.8266 10.8328 14.5409 10.2982 14.1213 9.87868C13.7018 9.45912 13.1672 9.1734 12.5853 9.05765C12.0033 8.94189 11.4001 9.0013 10.8519 9.22836C10.3038 9.45543 9.83524 9.83994 9.50559 10.3333C9.17595 10.8266 9 11.4067 9 12C9 12.7957 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15ZM12 10.5C12.2967 10.5 12.5867 10.588 12.8334 10.7528C13.08 10.9176 13.2723 11.1519 13.3858 11.426C13.4994 11.7001 13.5291 12.0017 13.4712 12.2926C13.4133 12.5836 13.2704 12.8509 13.0607 13.0607C12.8509 13.2704 12.5836 13.4133 12.2926 13.4712C12.0017 13.5291 11.7001 13.4994 11.426 13.3858C11.1519 13.2723 10.9176 13.08 10.7528 12.8334C10.588 12.5867 10.5 12.2967 10.5 12C10.5 11.6022 10.658 11.2206 10.9393 10.9393C11.2206 10.658 11.6022 10.5 12 10.5Z"
          fill={props?.color ?? "black"}
        />
        <path
          opacity="0.8"
          d="M18.75 3.75H16.5V3C16.5 2.60218 16.342 2.22064 16.0607 1.93934C15.7794 1.65804 15.3978 1.5 15 1.5H9C8.60218 1.5 8.22064 1.65804 7.93934 1.93934C7.65804 2.22064 7.5 2.60218 7.5 3V3.75H5.25C4.85218 3.75 4.47064 3.90804 4.18934 4.18934C3.90804 4.47064 3.75 4.85218 3.75 5.25V21C3.75 21.3978 3.90804 21.7794 4.18934 22.0607C4.47064 22.342 4.85218 22.5 5.25 22.5H18.75C19.1478 22.5 19.5294 22.342 19.8107 22.0607C20.092 21.7794 20.25 21.3978 20.25 21V5.25C20.25 4.85218 20.092 4.47064 19.8107 4.18934C19.5294 3.90804 19.1478 3.75 18.75 3.75ZM9 3H15V6H9V3ZM18.75 21H5.25V5.25H7.5V7.5H16.5V5.25H18.75V21Z"
          fill={props?.color ?? "black"}
        />
      </svg>
    </div>
  );
};

export default ManifestIcon;
